const en = {
	plInput: 'please enter',
	async: 'synchronization',
	cancel: 'cancel',
	confirm: 'determine',
	editSucces: 'modified successfully',
	editError: 'modification failed',
	add: 'add to',
	mobile: 'mobile phone',
	email: 'mailbox',
	major: 'major',
	team: 'team',
	avatar: 'head portrait',
	name: 'full name',
	eName: 'english name',
	cName: 'chinese name',
	phone: 'cell-phone number',
	tips: 'note: the following information is synchronized for reference only',
	allProject: 'all items',
	allClint: 'all end servers',
	plSelect: 'please select',
	parameter: 'parameter',
	note: 'Msg',
	plPhone: 'please enter your mobile number',
	allTeam: 'all teams',
	allMajor: 'all majors',
	centerSer: 'central server',
	plCorrectPhone: 'please give the correct mobile phone number',
	plrGraphicCode: 'please enter the graphic verification code',
	myPhone: 'current mobile number: ',
	myPhopneTips:
		' when modifying the mobile phone, the system will send the verification code to the new mobile phone number, and then enter the verification code to complete the modification.',
	back: 'return user login',
	adminLogin: 'background management login',
	serError: 'server error',
	noEmpty: 'cannot be empty',
	url: 'domain name',
	timeTips1: 'send sms too frequently, please',
	timeTips2: 'send the message again in seconds.',
	currentPage: 'current page of',
	page: 'page',
	go: 'go to',
	total: '',
	strip: '',
	emailError: 'the email format is incorrect, please check',
	updateInfo: 'modify information',
	info: 'essential information',
	updatePhone: 'modify mobile phone',
	accessSatus: 'connected',
	access: 'access',
	addSucces: 'added successfully',
	roleUpdateSucces: 'permission updated successfully',
	updateInfoSucces: 'basic information updated successfully',
	serverOffLine: 'the server is offline',
	asyncSucces: 'synchronization succeeded',
	backOff: 'to break off',
	passwordInequality: 'the two passwords are different, please re-enter',
	plCode: 'please enter the verification code',
	noSearch: "no search results yet. let's see others~",
	uploadFail: 'upload failed',
	search: 'search',
	wasNotFound: 'the result was not found',
	signOut: 'sign out',
	updateLanguage: 'update language',
	noData: 'no data',
	disconnected: 'disconnected',
	synchronizationSucceeded: 'synchronization succeeded',
	changeRecord: 'change record',
	exitSystem: 'exit the system',
	getInto: 'get into',
	allStates: 'all states',
	zh: 'chinese',
	en: 'english',
	selectMajorTag: 'please select professional label',
	selectTeamTag: 'please select a team tag',
	upload: 'upload',
	passwordResetSuccee: 'password reset succeeded',
	projectOverview: 'project overview ',
};

export default en;
